import React from "react";
import TrebbleSelect from "../common/TrebbleSelect";
import TrebbleInput from "../common/TrebbleInput";
import TrebbleFilterButtons from "../common/TrebbleFilterButtons";

interface FilterOption {
  key: string;
  label: string;
}

interface FilterBarProps {
  filters: FilterOption[];
  activeFilter: string;
  onFilterChange: (key: string) => void;
  sortOptions?: FilterOption[];
  activeSort?: string;
  onSortChange?: (key: string) => void;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  searchPlaceholder?: string;
  ti18n?: Record<string, string>;
}

const FilterBar: React.FC<FilterBarProps> = ({
  filters,
  activeFilter,
  onFilterChange,
  sortOptions,
  activeSort,
  onSortChange,
  searchQuery,
  onSearchChange,
  searchPlaceholder,
  ti18n,
}) => {
  const resolvedPlaceholder =
    searchPlaceholder ||
    (ti18n && typeof window !== "undefined" && typeof window.getI18n === "function"
      ? window.getI18n(ti18n, "SEARCH")
      : "Search...");
  return (
    <div className="flex items-center justify-between gap-3 py-3 flex-wrap">
      {/* Left side: filters + sort */}
      <div className="flex items-center gap-3 flex-wrap">
        <TrebbleFilterButtons
          filters={filters}
          activeFilter={activeFilter}
          onFilterChange={onFilterChange}
          useEditorTheme={false}
        />

        {/* Separator */}
        {sortOptions && sortOptions.length > 0 && onSortChange && (
          <div
            style={{
              width: 1,
              height: 20,
              backgroundColor: "var(--border-default-color, #ddd)",
            }}
          />
        )}

        {/* Sort dropdown */}
        {sortOptions && sortOptions.length > 0 && onSortChange && (
          <TrebbleSelect
            useEditorTheme={false}
            value={activeSort}
            onChange={(value: string) => onSortChange(value)}
            style={{ minWidth: 140 }}
            size="small"
            options={sortOptions.map((opt) => ({
              value: opt.key,
              label: opt.label,
            }))}
          />
        )}
      </div>

      {/* Right side: search */}
      {onSearchChange && (
        <TrebbleInput
          useEditorTheme={false}
          value={searchQuery || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
          placeholder={resolvedPlaceholder}
          allowClear
          style={{ width: 220 }}
          size="middle"
        />
      )}
    </div>
  );
};

export default FilterBar;
